var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    _vm._g(
      _vm._b(
        { attrs: { value: _vm.value, small: _vm.small } },
        "v-btn",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("v-icon", { attrs: { left: "", small: _vm.small, color: "delete" } }, [
        _vm._v("delete_forever"),
      ]),
      _vm._v(" "),
      _vm._t("default", function () {
        return [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }